<template>
  <div>
    <el-form
      label-position="right"
      label-width="80px"
      :model="fromdata"
      ref="fromdata"
      :rules="rules"
    >
      <el-form-item
        :label="dataobjs.banbenhao"
        style="padding-top: 30px"
        prop="version_number"
      >
        <el-input v-model="fromdata.version_number"></el-input>
      </el-form-item>
      <el-form-item
       :label="dataobjs.banbenjieshao"
        style="padding: 30px 0"
        prop="version_content"
      >
        <!-- <el-input v-model="fromdata.version_content"></el-input> -->
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 4 }"
          placeholder="请输入内容"
          v-model="fromdata.version_content"
        >
        </el-input>
      </el-form-item>
      <el-form-item :label="dataobjs.xiazaidizhi">
        <!-- <el-input v-model="fromdata.version_url"></el-input> -->
        <el-upload
          class="upload-demo"
          action="#"
          :auto-upload="false"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :on-change="flieChange"
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">{{dataobjs.dianjishangchuan}}</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="btenEtiel">
      <span slot="footer" class="dialog-footer list">
        <el-button @click="handhideNo()">{{dataobjs.quxiao}}</el-button>
        <el-button type="primary" @click="releaseHand">{{dataobjs.baocun}}</el-button>
      </span>
    </div>
  </div>
</template>

<script>
import { autoUpload, releaseReq } from "@/network/index";
export default {
  props: {
    fromdata: {
      type: Object,
      default: {},
    },
    dataobjs:{
      type:Object,
      default:{}
    },
    fileList: {
      type: Array,
      default: [],
    },
    handhide: {
      type: Function,
      default: Function,
    },
    appDataupdata: {
      type: Function,
      default: Function,
    },
  },
  data() {
    return {
      rules: {
        version_number: [
          { required: true, message: "请输入版本号", trigger: "blur" },
        ],
        version_content: [
          { required: true, message: "请输入版本介绍", trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    //  获取图片信息
    async flieChange(file) {
      // let fromData = new FormData()
      const lang_file = sessionStorage.getItem("lang_file");
      const token = sessionStorage.getItem("token");
      let forData = new FormData();
      let fileData = file.raw;
      forData.append("image", fileData);
      forData.append("appid", token);
      forData.append("lang_file", lang_file);
      forData.append("flag", 'app');
      forData.append("version", this.fromdata.version_number);
      const { code, data, msg } = await autoUpload(forData);
      this.fromdata.version_url = data;
    },
    // 发布信息
    async releaseHand() {
      //   console.log(this.fromdata);
      const { code, data, msg } = await releaseReq(this.fromdata);
      if (code) {
       
        this.appDataupdata();//更新数据
        this.handhide();
        this.$message.success(msg);
         this.$refs.fromdata.resetFields();
        return;
      }
      this.$message.error(msg);
    },
    // 取消
    handhideNo() {
      this.$refs.fromdata.resetFields();
      this.handhide();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
};
</script>

<style scoped >
.list {
  display: flex;
  justify-content: center;
}
</style>
